// Lightweight Zustand store mirroring just enough Auth0 state for the rest
// of the app to query without dragging the Auth0 SDK into every component.
// Auth0ProviderWithHistory is the sole writer; pages/components are readers.

import { create } from "zustand";

export interface AuthUser {
  sub: string;
  email?: string;
  name?: string;
  picture?: string;
}

interface AuthState {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setSession: (user: AuthUser | null, isAuthenticated: boolean) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  setSession: (user, isAuthenticated) => set({ user, isAuthenticated, isLoading: false }),
  setLoading: (loading) => set({ isLoading: loading }),
  reset: () => set({ user: null, isAuthenticated: false, isLoading: false }),
}));
